window.addEventListener('load', event => {
    // Onload Transition JS
    let jsshowonload = document.getElementById('js-show-on-load');
    if (jsshowonload) {
        document.getElementById('js-show-on-load').classList.remove('opacity-0');
        document.getElementById('js-show-on-load').classList.add('animate-fadeIn');
    }

    const callback = function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate-fadeIn');
                setTimeout(function() {
                    entry.target.classList.remove('opacity-0');
                }, 400);
            }
        });
    };

    const observer = new IntersectionObserver(callback);

    const targets = document.querySelectorAll('.js-show-on-scroll');
    targets.forEach(function(target) {
        target.classList.add('opacity-0');
        observer.observe(target);
    });
});
